import * as React from 'react';
import { StyledGrid } from './Grid.style';

type Props = {
    fluid?: boolean,
    gutter?: number | string
}

const Grid: React.FC<Props> = (props: any): React.ReactElement => {
    const {
        gutter,
        children,
        ...rest
    } = props;

    const styledChildren = React.Children.map(children, (child: any, index: number) => {
        if (child && child.type) {
            const childProps = { ...child.props };
            childProps.gutter = gutter;
            return React.cloneElement(child, childProps);
        }
        return child;
    });

    rest.gutter = gutter;
    rest.children = styledChildren;

    return <StyledGrid {...rest} />;
};

Grid.defaultProps = {
    gutter: 4
};

export default Grid;
